import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAll: function (params) {
    return axios.get(`${window.apiURL}api/distributions`, { params })
  },
  get: function (id) {
    return axios.get(`${window.apiURL}api/distributions/${id}`)
  },
  remove: function (id) {
    return axios.delete(`${window.apiURL}api/distributions/${id}`)
  },
  save: function (distribution) {
    let data = JSON.parse(JSON.stringify(distribution))

    if (data._id) {
      let id = data._id

      delete data._id
      delete data.createdAt
      delete data.updatedAt
      delete data.log
      delete data.logString

      if (data.artist && data.artist._id) {
        data.artist = data.artist._id
      }

      return axios.put(`${window.apiURL}api/distributions/${id}`, data)
    } else {
      return axios.post(`${window.apiURL}api/distributions`, distribution)
    }
  },
  getCovers: function () {
    return axios.get(`${window.apiURL}api/covers`)
  },
  getStores: function (id) {
    return axios.get(`${window.apiURL}api/distribution/${id}/stores`)
  },
  updateDeliveryDsps: function (id) {
    return axios.get(`${window.apiURL}api/distribution/${id}/deliveries`)
  },
  getCopyrightIssue: function (id, songId) {
    return axios.get(`${window.apiURL}api/copyright-issues`, { params: { distribution: id, song_id: songId } })
  },
  getAvailableDistributions: function () {
    return axios.get(`${window.apiURL}api/distribution-limit`)
  },
  getPublicRelease: function (key) {
    return axios.get(`${window.apiURL}api/release/${key}`)
  },
  getMetadataLimit: function (id) {
    return axios.get(`${window.apiURL}api/distribution-metadata-limit/${id}`)
  },
  sendMetadataRequest: function (data) {
    if (data.distribution._id) {
      return axios.put(`${window.apiURL}api/distribution-metadata/${data.distribution._id}`, data)
    }
  },
  setReopenInProgress: function (id) {
    return axios.put(`${window.apiURL}api/distribution/${id}/reopen-reason`)
  },
  saveUrlFiles: function (id, filesToVerification) {
    return axios.put(`${window.apiURL}api/distribution/${id}/url-files`, { params: { urlFiles: filesToVerification } })
  },
  requestPromoVideos: function (id) {
    return axios.put(`${window.apiURL}api/distribution/${id}/request-videos`)
  },
  setTakedown: function (id, dataToSend) {
    return axios.put(`${window.apiURL}api/takedown/${id}`, dataToSend)
  },
  cancelTakedown: function (id) {
    return axios.put(`${window.apiURL}api/takedown/cancel/${id}`)
  },
  saveMetadaRequest: function (id, origin, dataToSend) {
    return axios.put(`${window.apiURL}api/distribution/${id}/metadata-request`, { params: { origin: origin, metadata_request_data: dataToSend } })
  },
  confirmMetadaRequest: function (id, serviceId) {
    return axios.put(`${window.apiURL}api/distribution/${id}/confirm-metadata-request`, { params: { service: serviceId } })
  },
  revertChangesMetadaRequest: function (id, origin) {
    return axios.put(`${window.apiURL}api/distribution/${id}/revert-metadata-request`, { params: { origin: origin } })
  },
  getResquestByMonth: function () {
    return axios.get(`${window.apiURL}api/distribution/requested-by-month`)
  },
  getAllDsps: function (params) {
    return axios.get(`${window.apiURL}api/distribution/dsps`, { params })
  },
  submitSong: function (data) {
    return axios.post(`${window.apiURL}api/playlisting/submit`, data)
  },
  getComments: function (id) {
    return axios.get(`${window.apiURL}api/distribution/${id}/comments`)
  },
  postComment: function (id, strength, areasOfImprovement, author) {
    return axios.post(`${window.apiURL}api/distribution/${id}/comments`, { strength, areas_of_improvement: areasOfImprovement, author })
  },
  featureRelease: function (id) {
    return axios.put(`${window.apiURL}api/distribution/${id}/feature`)
  }
}



// WEBPACK FOOTER //
// ./src/services/distributions.js